import {CLEAR_ERROR} from "./constant";

export const clearError = () => ({
  type: CLEAR_ERROR,
});
